import React from 'react';
import { ResizableBox } from 'react-resizable';

import * as styles from './Sidebar.css';

type SidebarProps = {
  open: boolean;
  dock?: 'left' | 'right';
  width?: number;
  initialWidth?: number;
  minWidth?: number;
  maxWidth?: number;
  onResize?: (width: number) => void;
  top?: number | string;
  left?: number | string;
  right?: number | string;
  children: React.ReactNode;
};

export function Sidebar({
  open,
  dock = 'left',
  width,
  initialWidth = 256,
  minWidth = 200,
  maxWidth = 1080,
  onResize,
  top,
  left,
  right,
  children,
}: SidebarProps) {
  if (!open) return null;

  const isLeft = dock === 'left';
  const sidebarClass = isLeft ? styles.sidebarLeft : styles.sidebarRight;
  const sidebarWidth = width ?? initialWidth;

  // Compute dynamic style for top/left/right
  const sidebarStyle: React.CSSProperties = isLeft
    ? {
        top: top ?? 40,
        left: left ?? 0,
      }
    : {
        top: top ?? 40,
        right: right ?? 0,
      };

  return (
    <div className={sidebarClass} style={sidebarStyle}>
      <ResizableBox
        width={sidebarWidth}
        height={Infinity}
        className={styles.mainContent}
        axis="x"
        minConstraints={[minWidth, 0]}
        maxConstraints={[maxWidth, 0]}
        handle={<div className={isLeft ? styles.resizerHandleLeft : styles.resizerHandleRight} />}
        handleSize={[10, 52]}
        onResize={(_e: unknown, data: { size: { width: number } }) => onResize?.(data.size.width)}
        resizeHandles={[isLeft ? 'e' : 'w']}
      >
        {children}
      </ResizableBox>
    </div>
  );
}
